export default class imageEditor {
    constructor() {
        return {
            scope: false,
            controller: 'ImageEditorCtrl',
            template: require('../../../../views/directives/image-bank/image-editor.html')
        }
    }
}